import { isUndefined } from '../../../predicates/type';
import { CustomObject } from '../../../types';
import { Fn } from '../../../types/function';
import { CombineNormalizerAtoms } from '../types';

export const combineNormalizerAtoms: CombineNormalizerAtoms = function ({
	atoms,
	value,
	prevValue,
	fulfilledValueIndicator,
	options: optionsFromProps,
	transformers,
	primitiveValidators,
}) {
	let stopPipeline = false;
	let transformedValue = value;
	const options = optionsFromProps || {};

	if (!isUndefined(transformers)) {
		transformedValue = transformers.reduce((memo, transformer) => {
			return transformer(memo, options);
		}, transformedValue);
	}

	if (!isUndefined(primitiveValidators)) {
		const hasInvalidValue = primitiveValidators.some((validator) => !validator(transformedValue, options));

		if (hasInvalidValue) {
			return prevValue;
		}
	}

	return atoms.reduce((memo, atom) => {
		if (stopPipeline) {
			return memo;
		}

		if (!isUndefined(fulfilledValueIndicator) && !fulfilledValueIndicator(memo, options)) {
			stopPipeline = true;

			return memo;
		}

		const result = atom({ value: memo, prevValue }, options);

		if (!result.success) {
			stopPipeline = true;

			return prevValue;
		}

		return result.value;
	}, transformedValue);
};

export function combineFormatAtoms<T extends Fn>(atoms: Array<T>, value: unknown, options?: CustomObject) {
	let stopPipeline = false;

	return atoms.reduce((memo, atom) => {
		if (stopPipeline) {
			return memo;
		}

		const result = atom(memo, options);

		if (!result.success) {
			stopPipeline = true;
		}

		return result.value;
	}, value);
}
